import React from 'react';
import { Card } from "react-bootstrap";
import face_image_1 from "../../assets/img/faceSaraMarin.jpeg";
import face_image_2 from "../../assets/img/faceMarcellNagy.png";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projNagyM_SaraM_mlops.png";

const M_Nagy_and_S_Marin_mlops = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_image_1}
              
            />{" "}
            <p className="text7">Sara Marin{" "}</p>
            <br />
            <p className="text8">
              AI & ML Experts{" "}   {/* This is an exception, because the position is the same */}
            </p>
            <p className="text8">INSUS </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_image_2}
              
            />{" "}
            <p className="text7">Marcell Nagy{" "}</p>
            <br />
            <p className="text8">
              {" "}  {/* This is an exception, because the position is the same */}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In industrial AI applications, developing a high-performing model is only a small part of the lifecycle. To provide 
            real-world value, models must be robust, maintainable, and capable of adapting to changing environments. This project 
            focuses on the full lifecycle of a Machine Learning product—often referred to as MLOps.
            <br/>
            <br/>
            Using the context of industrial sustainability (e.g., air quality monitoring or energy/fuel price forecasting), 
            students will build an automated, end-to-end ML pipeline. The project involves:
            <ol>
                <li>
                    <b>Data Engineering:</b> Designing automated data ingestion pipelines than continuously collect and update data 
                    from live sources (e.g., web scraping or APIs).
                </li>
                <li>
                    <b>Modeling:</b> Training and validating predictive models (e.g., time-series forecasting or regression).
                </li>
                <li>
                    <b>Deployment:</b> Wrapping the model into a live web application.
                </li>
                <li>
                    <b>Monitoring & Maintenance:</b> Implementing automated monitoring, including data/concept drift detection, to 
                    ensure the model remains accurate as live data evolves over time, and enabling model retraining when necessary.
                </li>
            </ol>
            
            Through this project, students will gain hands-on experience in turning a mathematical model into a "live" service, 
            bridging the gap between theoretical data science and production-ready software engineering.

            <br/>
            <br/>
            <b>Requirements</b>
            <br/>
            <br/>
            Required:
            <ul>
                <li>
                    Solid programming skills (Python preferred)
                </li>
                <li>
                    Good understanding of Machine Learning fundamentals
                </li>
            </ul>
            
            <br/>
            Good to have:
            <ul>
                <li>
                    Experience with ML libraries (e.g., Scikit-learn, PyTorch)
                </li>
                <li>
                    Familiarity with Git
                </li>
                <li>
                    Experience with web frameworks (e.g., Streamlit, FastAPI)
                </li>
                <li>
                    Basic familiarity with end-to-end ML pipelines, including data ingestion, model deployment, CI/CD workflows, and monitoring
                </li>
            </ul>



            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default M_Nagy_and_S_Marin_mlops;